import { InvoiceLineModel } from './invoiceline.model';
import { QRCodeModel } from '../../qr/qrcode.model';

export class PreinvoiceModel {
  uid: string;
  activityUid: string;

  invoiceLines: Array<InvoiceLineModel>;
  published: boolean;
  contabilized: boolean;
  issuerName: string;
  issuerVatNumber: string;
  issuerAddress: string;
  issuerLocation: string;
  issuerPostalCode: string;
  issuerState: string;
  issuerCountry: string;

  receiverUid: string;
  receiverName: string;
  center: string;
  centerUid: string;

  preInvoiceNumber: string;
  invoiceNumber: string;
  invoiceRelease: Date;
  invoiceExpiration: Date;
  received: Date;
  sendedMail: Date;
  paided: Date;
  returned: Date;
  recurrentNumber: string;
  recurrentFrequency: string;
  recurrentStart: Date;
  recurrentFrequencyDays: number;
  isNative: boolean;
  isReceptor: boolean;
  base: number;
  total: number;
  typePay: string;

  typePayBankAccount: string;
  payBankAccount: string;
  expenseAccount: string;
  entranceAccount: string;
  rectifying: boolean;
  comments: string;
  qrcode: QRCodeModel;
  qrstring: string;
  publish: boolean;
  preinvoicePublished: boolean;
  fiscalYear: number;

  numberKilometers: number;

  efectivoId: string;
  partnersId: number;
  projectUid?: string;
  expenseProjectTypeUid?: string;

  useDeliverAddress: boolean;

  constructor() {
  }
}
